import React from "react";
import { SegmentedControl } from "@amzn/awsui-components-react";
import { CopyToClipboard } from "../common/CopyToClipboard";
import { SavedViewsManager } from "./SavedViewsManager";
import { SavedDashboardView } from "../../hooks/useSavedDashboardViews";
import { Stage } from "../../lusca-search-api/generated-src";

interface DashboardStageSelectorProps {
  stage: Stage;
  setStage: (stage: Stage) => void;
  getShareUrl: (() => Promise<string>) | null;
  getCompressedFilters: (() => Promise<string>) | null;
  onLoadView: (view: SavedDashboardView | null) => void;
  activeViewName: string | null;
  setActiveViewName: (name: string | null) => void;
}

export const DashboardStageSelector: React.FC<DashboardStageSelectorProps> = ({
  stage,
  setStage,
  getShareUrl,
  getCompressedFilters,
  onLoadView,
  activeViewName,
  setActiveViewName,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <SegmentedControl
        selectedId={stage}
        onChange={({ detail }) => setStage(detail.selectedId as Stage)}
        options={[
          { id: Stage.Prod, text: Stage.Prod },
          { id: Stage.Gamma, text: Stage.Gamma },
        ]}
      />
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <SavedViewsManager
          getFilters={getCompressedFilters}
          stage={stage}
          onLoadView={onLoadView}
          activeViewName={activeViewName}
          setActiveViewName={setActiveViewName}
        />
        <CopyToClipboard
          getContent={getShareUrl || (async () => "")}
          disabled={!getShareUrl}
          iconName="share"
          variant="icon"
          ariaLabel="Copy share link with current filters"
        />
      </div>
    </div>
  );
};
